import { render, staticRenderFns } from "./form.vue?vue&type=template&id=15b00e9b"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b00e9b')) {
      api.createRecord('15b00e9b', component.options)
    } else {
      api.reload('15b00e9b', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=15b00e9b", function () {
      api.rerender('15b00e9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/approved-message/form.vue"
export default component.exports